import React, { useState } from 'react';
const InputField = ({
  label,
  type = 'text',
  name,
  value,
  onChange,
  placeholder,
  error
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const hasValue = value && value.length > 0;
  return <div className="mb-4" data-id="element-83">
      <div className="relative" data-id="element-84">
        <input id={name} name={name} type={type} value={value} onChange={onChange} placeholder={placeholder} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} className={`w-full px-4 py-3.5 rounded-xl transition-all duration-200 bg-blue-50 text-gray-900 border-2 ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-200' : isFocused ? 'border-blue-500 ring-4 ring-blue-100' : 'border-blue-200 hover:border-blue-300 focus:border-blue-500 focus:ring-blue-100'} outline-none`} data-id="element-85" />
        <label htmlFor={name} className={`absolute left-3 transition-all duration-200 pointer-events-none ${isFocused || hasValue ? 'text-xs font-medium text-blue-600 px-1 -top-2 bg-blue-50' : 'text-gray-500 top-3.5'}`} data-id="element-86">
          {label}
        </label>
      </div>
      {error && <p className="mt-1.5 text-sm text-red-600 pl-1" data-id="element-87">{error}</p>}
    </div>;
};
export default InputField;